module.exports = __webpack_public_path__ + "images/navbar/airc-tree.694a4bd4cb3f49267522fe0973e6e47a.png";